var _style, _defs;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgLine(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 1 67",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _style || (_style = /*#__PURE__*/React.createElement("style", null, "@keyframes fadeOut{0%,to{opacity:.6}50%{opacity:.3}}")), /*#__PURE__*/React.createElement("path", {
    stroke: "url(#line_svg__paint0_linear)",
    style: {
      animationName: "fadeOut",
      animationDuration: "1.5s",
      animationDelay: "0s",
      animationTimingFunction: "ease",
      animationIterationCount: "infinite"
    },
    d: "M.5 0v67"
  }), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "line_svg__paint0_linear",
    x1: 0,
    y1: 33.5,
    x2: 0,
    y2: 0,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ADA06E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ADA06E",
    stopOpacity: 0
  })))));
}

export default "data:image/svg+xml;base64,PHN2ZyB2aWV3Qm94PSIwIDAgMSA2NyIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KICA8c3R5bGU+CiAgICAubGluZSB7CiAgICAgIGFuaW1hdGlvbi1uYW1lOiBmYWRlT3V0OwogICAgICBhbmltYXRpb24tZHVyYXRpb246IDEuNXM7CiAgICAgIGFuaW1hdGlvbi1kZWxheTogMHM7CiAgICAgIGFuaW1hdGlvbi10aW1pbmctZnVuY3Rpb246IGVhc2U7CiAgICAgIGFuaW1hdGlvbi1pdGVyYXRpb24tY291bnQ6IGluZmluaXRlOwogICAgfQoKICAgIEBrZXlmcmFtZXMgZmFkZU91dCB7CiAgICAgIDAlIHsKICAgICAgICBvcGFjaXR5OiAwLjY7CiAgICAgIH0KICAgICAgNTAlIHsKICAgICAgICBvcGFjaXR5OiAwLjM7CiAgICAgIH0KICAgICAgMTAwJSB7CiAgICAgICAgb3BhY2l0eTogMC42OwogICAgICB9CiAgICB9CiAgPC9zdHlsZT4KICA8bGluZSBjbGFzcz0ibGluZSIgeDE9IjAuNSIgeTE9IjIuMTg1NTdlLTA4IiB4Mj0iMC40OTk5OTciIHkyPSI2NyIgc3Ryb2tlPSJ1cmwoI3BhaW50MF9saW5lYXIpIi8+CiAgPGRlZnM+CiAgICA8bGluZWFyR3JhZGllbnQgaWQ9InBhaW50MF9saW5lYXIiIHgxPSIwIiB5MT0iMzMuNSIgeDI9IjAiIHkyPSIwIiBncmFkaWVudFVuaXRzPSJ1c2VyU3BhY2VPblVzZSI+CiAgICAgIDxzdG9wIHN0b3AtY29sb3I9IiNBREEwNkUiLz4KICAgICAgPHN0b3Agb2Zmc2V0PSIxIiBzdG9wLWNvbG9yPSIjQURBMDZFIiBzdG9wLW9wYWNpdHk9IjAiLz4KICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgPC9kZWZzPgo8L3N2Zz4K";
export { SvgLine as ReactComponent };